import React from "react";
import { motion } from "framer-motion";
import { whyChooseaData } from "../Data";

const WhyChoose = () => {

  // Section stagger
  const container = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2,
      },
    },
  };

  // Text reveal (clean + strong)
  const fadeUp = {
    hidden: { y: 40, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  // Cards (structured placement feel)
  const cardAnim = {
    hidden: { y: 30, opacity: 0, scale: 0.95 },
    visible: {
      y: 0,
      opacity: 1,
      scale: 1,
      transition: {
        type: "spring",
        stiffness: 140,
        damping: 12,
      },
    },
  };

  // Icon pop
  const iconAnim = {
    hidden: { scale: 0.7, opacity: 0 },
    visible: {
      scale: 1,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 180,
        damping: 10,
      },
    },
  };

  return (
    <section className="why-choose-section">

      {/* DOTS (refined pulse) */}
      <motion.div
        className="why-choose-dots"
        animate={{
          scale: [1, 1.25, 1],
          opacity: [0.5, 1, 0.5],
        }}
        transition={{
          duration: 2.5,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />

      <div className="container">

        {/* TEXT CONTENT */}
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          <motion.h3 className="section-subheading" variants={fadeUp}>
            Why Choose us ?
          </motion.h3>

          <motion.h2 className="section-heading" variants={fadeUp}>
            Why Professionals Choose VigoFlex ?
          </motion.h2>

          <motion.p className="section-text" variants={fadeUp}>
          Trusted by professionals for its consistent performance, strong bonding strength, and ease of application across a wide range of surfaces. Designed to deliver reliable results on every project, our solutions help save time, reduce failures, and ensure long-lasting tile installations.
          </motion.p>
        </motion.div>

        {/* CARDS GRID */}
        <motion.div
          className="why-choose-grid"
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {whyChooseaData.map((item, i) => (
            <motion.div
              className="why-choose-card"
              key={i}
              variants={cardAnim}
              whileHover={{ y: -6, scale: 1.02 }} // firm lift
            >
              <motion.div
                className="why-choose-icon"
                variants={iconAnim}
              >
                <img src={item.icon} alt={`${item.title} | VigoFlex`} />
              </motion.div>

              <h4 className="card-heading">{item.title}</h4>
              <p className="section-text">{item.desc}</p>
            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  );
};

export default WhyChoose;